import { BroadcastService } from './../../services/share/broadcast.service';
import { EventPopoverPage } from './../../components/event-popover/event-popover.page';
import { EventsCalendarService } from 'src/app/services/events-calendar/events-calendar.service';
import { Component, ViewChild, OnInit } from '@angular/core';
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import { SubSink } from 'subsink';
import { PopoverController, ToastController } from '@ionic/angular';
import { RegisterResetpassService } from 'src/app/services/register-resetpass/register-resetpass.service';
import { environment } from 'src/environments/environment';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { PlatformService } from 'src/app/services/platform/platform.service';
import { RangeCustomEvent } from '@ionic/angular';
import { RangeValue } from '@ionic/core';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.page.html',
  styleUrls: ['./calendar.page.scss'],
})
export class CalendarPage implements OnInit {
  moment: any = moment;
  isMobileDevice: boolean;

  subscription = new SubSink();
  allEvents: any;
  event: any;
  dateEvents: any;
  filteredEvents: any;
  date_selected: any = new Date();
  date_pipe = new DatePipe('en-us');

  start_date_selected: any = new Date();
  end_date_selected: any = new Date();

  prev_cells: any;
  next_cells: any;

  prev: any;
  next: any;

  isFilterEventsModalOpen: boolean = false;

  calendarOptions: CalendarOptions;
  s3_url = environment.s3_bucket_url;

  profilePlaceholder: string = '/assets/images/profile-placeholder.png';

  roles: any;

  showDateEventsLoader: boolean = false;

  selectedAccountType = 'all';

  moveEnd: RangeValue = 50;

  distance: RangeValue = null;

  categoriesArray = [];

  keyword_search: string = "";

  isShowMap: boolean = true;
  isShowList: boolean = false;

  showRadialDistance: boolean = false;

  @ViewChild('calendar') calendar: FullCalendarComponent;
  @ViewChild(MapInfoWindow) infoWindowsView: MapInfoWindow;

  @ViewChild('category_select') selected_category: any;

  info_content: string = '';
  display: any;
  center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };
  zoom = 4;
  artistsmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/artists-marker.png',
  };
  bandsmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/bands-marker.png',
  };
  venuesmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/venues-marker.png',
  };
  usermarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/user-marker.png',
  };
  comediansmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/comedians-marker.png',
  };
  comedyclubsmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/comedyclub-marker.png',
  };
  foodtrucksmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/foodtruck-marker.png',
  };
  bandMarkerPositions: google.maps.LatLngLiteral[] = [];
  bandPostions: any = [];

  profileImage: string = null;
  eventTitle: string = '';
  eventDate: string = '';
  eventStartTime: string = '';
  eventEndTime: string = '';
  time: string = '';
  eventDescription: string = '';
  fullName: string = '';
  whereEvent: string = '';
  eventAddress: string = '';

  isCalendarView: boolean = true;
  isMapView: boolean = false;
  isLoggedIn: boolean = false;

  public innerWidth: any;

  showSpinner: boolean = false;
  response_message: string = '';

  constructor(
    private router: Router,
    public popover: PopoverController,
    private registerService: RegisterResetpassService,
    private eventsService: EventsCalendarService,
    private platform: PlatformService,
    private broadcastService : BroadcastService,
    private toast: ToastController
  ) {
    Window['myComponent'] = this;
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
    this.removeActiveDateClass();
  }

  ionViewWillEnter() {
    if(this.isUserLoggedIn()){
      this.isLoggedIn = true;
    }

    this.broadcastService.coordinate$.subscribe((res:any)=>{
      this.eventsService.latitude(res.coordinate.latitude);
      this.eventsService.longitude(res.coordinate.longitude);
    });

    this.showCalendar();
  }

  isUserLoggedIn(){
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    }else{
      return false;
    }
  }

  ionViewDidEnter() {
    this.getUserAccountTypes();
    this.getPrevArrow();
    this.getNextArrow();
    this.getPrevArrowDateRange();
    this.getNextArrowDateRange();
  }

  showCalendar() {
    this.calendarOptions = {
      height: 'auto',

      headerToolbar: {
        left: 'prev',
        center: 'title',
        right: 'next',
      },

      views: {
        dayGridMonth: {
          titleFormat: { year: 'numeric', month: 'long' }
        },
        dayGridWeek: {
          titleFormat: { year: 'numeric', month: 'long' },
          // dayHeaderFormat: { weekday: 'short', day: 'numeric' }
          dayHeaderContent: (args) => {
            return moment(args.date).format('ddd D');
          },
        }
      },

      initialDate: new Date(),
      events: [],

      eventClick: (info) => {
        let jsEvent = info.jsEvent;
        let event_id: any = info.event._def.extendedProps.eventId;
        let index: any = this.allEvents.findIndex((element) => {
          return element.id == event_id;
        });
        let my_event: any = this.allEvents[index];
        this.showPopover(my_event, jsEvent);

      },

    };

    let cal = this.calendar.getApi();
    if (window.innerWidth < 1024) {
      cal.changeView('dayGridWeek');
      this.getStartEndDate();
      // this.getDateEvents();
      this.getHeaderDate();
      this.getPrevArrow();
      this.getNextArrow();
    } else {
      cal.changeView('dayGridMonth');
      this.getStartEndDate();
      // this.filterEvents();
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024) {
        cal.changeView('dayGridWeek');
      } else {
        cal.changeView('dayGridMonth');
      }
    });
  }

  getPrevArrowDateRange() {
    this.prev_cells = document.querySelectorAll('.fc-prev-button');
    this.prev_cells.forEach((elem:HTMLAnchorElement) => {elem.onclick = e => {
      this.getStartEndDate();
    }});
  }

  getNextArrowDateRange() {
    this.next_cells = <NodeList>document.querySelectorAll('.fc-next-button');
    this.next_cells.forEach((elem:HTMLAnchorElement) => {elem.onclick = e => {
      this.getStartEndDate();
    }});
  }

  getStartEndDate() {
    let cal = this.calendar.getApi();
    let cal_start_date = cal.view.currentStart;
    let cal_end_date = cal.view.currentEnd;
    this.start_date_selected = this.date_pipe.transform(cal_start_date,'yyyy-MM-dd');
    this.end_date_selected = this.date_pipe.transform(cal_end_date,'yyyy-MM-dd');
    // console.log(this.start_date_selected, ' to ', this.end_date_selected);
    let data = {
      start_date: this.start_date_selected,
      end_date: this.end_date_selected,
    }
    this.getEventsByDateRange(data);
  }

  removeActiveDateClass() {
    var header_cell = document.querySelectorAll('.fc-col-header-cell');
    header_cell.forEach((el) => el.classList.remove('date-active'));
  }

  getHeaderDate() {
    var header_cell = document.querySelectorAll('.fc-col-header-cell');
    header_cell.forEach((elem:HTMLAnchorElement) => {elem.onclick = e => {
      header_cell.forEach((el) => el.classList.remove('date-active'));
      elem.classList.add("date-active");
      this.date_selected = elem.getAttribute('data-date');
      // console.log("date selected ==> ",this.date_selected);
      this.filterAccountTypeDateEvents();
    }});

  }

  getPrevArrow() {
    var cells = document.querySelectorAll('.fc-prev-button');
    cells.forEach(elem => elem.addEventListener('click', () => this.getHeaderDate()));
  }

  getNextArrow() {
    var cells = document.querySelectorAll('.fc-next-button');
    cells.forEach(elem => elem.addEventListener('click', () => this.getHeaderDate()));
  }

  hideCalendarMonthViewGrid() {
    document.querySelector('.fc-view-harness-passive').classList.add("hidden");
  }

  showCalendarMonthViewGrid() {
    document.querySelector('.fc-view-harness-passive').classList.remove("hidden");
  }

  async showPopover(event_details, jsEvent) {
    const pop = await this.popover.create({
      component: EventPopoverPage,
      componentProps: { eventDetails: event_details },
      event: jsEvent,
      cssClass: 'event-popover'
    });
    pop.present();

    jsEvent.preventDefault(); // don't let the browser navigate/scroll after dismiss
    await pop.onDidDismiss();
  }


  async showMobilePopover(event_details) {
    const pop = await this.popover.create({
      component: EventPopoverPage,
      componentProps: { eventDetails: event_details },
      cssClass: 'event-popover'
    });
    pop.present();
    await pop.onDidDismiss();
  }

  getDateEvents() {
    let today_date = this.date_pipe.transform(Date.now(),'yyyy-MM-dd');
    let data = {
      selected_date: today_date
    };
    var cells = document.querySelectorAll(`[data-date='${today_date}']`);
    cells.forEach((elem) => {
      elem.classList.add("date-active");
    });
    this.getEventsByDate(data);
  }

  getAllEvents() {
    this.subscription.sink = this.eventsService.getAllEvents().subscribe(
      (res: any) => {
        this.allEvents = res.data;
        this.showEventsGoogleMap(this.allEvents);
        // console.log("all events details ---> ",this.allEvents);
        if (res.data && this.calendar) {
          this.calendarOptions.events = this.allEvents.map((evt) => {
            return {
              title: evt.event_title,
              date: evt.event_date,
              eventId: evt.id,
            };
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserAccountTypes() {
    this.subscription.sink = this.registerService.getAccountTypes().subscribe(
      (roles: any[]) => {
        this.roles = roles['data'];
      },
      (error) => console.log(error)
    );
  }

  getAccountTypeEvents(account_type_id) {
    this.subscription.sink = this.eventsService
      .getAccountTypeEvents(account_type_id)
      .subscribe(
        (events: any[]) => {
          let filtered_events = events['data'];
          this.showEventsGoogleMap(filtered_events);
          if (filtered_events && this.calendar) {
            this.calendarOptions.events = filtered_events.map((evt) => {
              return {
                title: evt.event_title,
                start: evt.event_date,
                end: evt.event_end_date,
                eventId: evt.id,
              };
            });
          }
        },
        (error) => console.log(error)
      );
  }

  getEventsByDate(selected_date) {
    this.subscription.sink = this.eventsService.getEventsByDate(selected_date).subscribe(
      (events: any[]) => {
        this.dateEvents = events['data'];
        this.showEventsGoogleMap(this.dateEvents);
        this.showDateEventsLoader = false;
      },
      (error) => {
        console.log(error);
        this.showDateEventsLoader = false;
      }
    );
  }

  filterEvents(evt = null) {
    if(evt?.srcElement)
      this.selectedAccountType = evt.srcElement.value;
    if (this.selectedAccountType === 'all') {
      this.getAllEvents();
    } else {
      this.getAccountTypeEvents(this.selectedAccountType);
    }

  }

  containsActiveClass(): boolean {
    var header_cell = document.querySelectorAll('.fc-col-header-cell');
    let return_value = false;
    header_cell.forEach((el) => {
      if (el.classList.contains('date-active')) {
        return_value = true;
      };
    });
    return return_value;
  }


  filterAccountTypeDateEvents(evt = null) {
    if(evt?.srcElement) {
      this.selectedAccountType = evt.srcElement.value;
    }

    if (this.isMobileDevice) {
      if (this.selectedAccountType === 'all') {
        if (this.containsActiveClass()) {
          // console.log("all and active");
          let data = {
            selected_date: this.date_selected
          }
          this.getEventsByDate(data);
        } else {
          // console.log("all and range");
          let data = {
            start_date: this.start_date_selected,
            end_date: this.end_date_selected,
          }
          this.getEventsByDateRange(data);
        }
      } else {
        if (this.containsActiveClass()) {
          // console.log("account type and active");
          let data = {
            start_date: this.date_selected,
            end_date: this.date_selected,
            account_type_id: this.selectedAccountType
          }
          this.getAccountTypeDateEvents(data);
        } else {
          // console.log("account type and range");
          let data = {
            start_date: this.start_date_selected,
            end_date: this.end_date_selected,
            account_type_id: this.selectedAccountType
          }
          this.getAccountTypeDateEvents(data);
        }
      }
    } else {
      if (this.selectedAccountType === 'all') {
        let data = {
          start_date: this.start_date_selected,
          end_date: this.end_date_selected,
        }
        this.getEventsByDateRange(data);
      } else {
        let data = {
          start_date: this.start_date_selected,
          end_date: this.end_date_selected,
          account_type_id: this.selectedAccountType
        }
        this.getAccountTypeDateEvents(data);
      }
    }

  }

  getAccountTypeDateEvents(data) {
    this.subscription.sink = this.eventsService.getAccountTypeDateEvents(data).subscribe(
      (events: any[]) => {
        this.dateEvents = events['data'];
        if (!this.isMapView && this.calendar) {
          this.calendarOptions.events = this.dateEvents.map((evt) => {
            return {
              title: evt.event_title,
              start: evt.event_date,
              end: evt.event_end_date,
              eventId: evt.id,
            };
          });
        } else {
          this.showEventsGoogleMap(this.dateEvents);
        }
      },
      (error) => {
        console.log(error);
      }
    )
  }

  getEventsByDateRange(data) {
    this.subscription.sink = this.eventsService.getEventsByDateRange(data).subscribe(
      (events: any[]) => {
        this.allEvents = events['data'];
        this.dateEvents = events['data'];
        if (!this.isMapView && this.calendar) {
          this.calendarOptions.events = this.allEvents.map((evt) => {
            return {
              title: evt.event_title,
              start: evt.event_date,
              end: evt.event_end_date,
              eventId: evt.id,
            };
          });
        } else {
          console.log("fijfiefei iwjfiowfw ")
          this.showEventsGoogleMap(this.dateEvents);
        }
        // console.log("all events ==> " ,this.allEvents)
      },
      (error) => {
        console.log(error);
      }
    )
  }


  public openInfoWindow(marker: MapMarker, msg: string) {
    this.info_content = msg;
    this.infoWindowsView.open(marker);
  }

  showEventsGoogleMap(events) {
    // console.log('map events --> ', events);
    this.bandMarkerPositions = [];
    this.bandPostions = [];
    events.forEach((event) => {
      let slug = 'user';
      let options = null;
      if (event?.user?.account_type?.id == 1) {
        slug = 'band';
        options = this.bandsmarkerOptions;
      } else if (event?.user?.account_type?.id == 2) {
        slug = 'comedian';
        options = this.comediansmarkerOptions;
      } else if (event?.user?.account_type?.id == 3) {
        slug = 'food-truck';
        options = this.foodtrucksmarkerOptions;
      } else if (event?.user?.account_type?.id == 4) {
        slug = 'user';
        options = this.usermarkerOptions;
      } else if (event?.user?.account_type?.id == 5) {
        slug = 'venue';
        options = this.venuesmarkerOptions;
      } else if (event?.user?.account_type?.id == 6) {
        slug = 'comedy-club';
        options = this.comedyclubsmarkerOptions;
      } else if (event?.user?.account_type?.id == 7) {
        slug = 'artist';
        options = this.artistsmarkerOptions;
      }
      let profile_pic: string = event.user.user_account_information
        ?.profile_image
        ? this.s3_url + event.user.user_account_information?.profile_image
        : this.profilePlaceholder;
      let eventDate: string = '';
      eventDate = moment(event.event_date).format('MMMM D, YYYY');
      let eventStartTime: string = '';
      let eventEndTime: string = '';
      let time: string = '';
      // console.log('start time --> ', event?.event_start_time);
      if (event.event_start_time !== null && event.event_end_time !== null) {
        eventStartTime = moment(event.event_start_time, 'HH:mm:ss').format(
          'hh:mm A'
        );
        eventEndTime = moment(event.event_end_time, 'HH:mm:ss').format(
          'hh:mm A'
        );
        time = eventStartTime + ' - ' + eventEndTime;
      } else {
        time = 'All Day';
      }
      let eventDescription: string = '';
      if (event.event_description !== '') {
        eventDescription = event.event_description;
      } else {
        eventDescription = 'N/A';
      }

      // console.log('time --> ', time);
      this.bandPostions.push({
        options: options,
        message:
        `<div class="bg-grunge p-3 flex map_window">
        <img class=" max-w-sm pr-4" src="`+profile_pic+`">
        <div class="text-center flex-1">
          <h1 class="uppercase">`+event?.event_title+`</h1>
          <a onclick="Window.myComponent.goToProfile('`+event?.user_id+`', '`+event?.user?.account_type?.id+`')" class="uppercase cursor-pointer">[View profile]</a>
        </div>
      </div>
      <div class="-mt-2 mx-2 bg-cll-danger map_info_event uppercase text-white">
      <p class="mb-2">
              <span class="text-white font-bold">Date & Time: </span>
              ` +
            eventDate +
            ' ' +
            time +
            `
            </p>
        <p class="mb-2">
          <span class="text-white font-bold">Event Description: </span>
          `+eventDescription+`
        </p>
        <p class="mb-5">
          <span class="text-white font-bold">Who: </span>
          `+event?.user?.first_name +' '+event?.user?.last_name+`
        </p>
        <p class="mb-2">
          <span class="text-white flex justify-between">
            <span>
              <span class="font-bold">Where: </span>
              `+event.where_event+`
            </span>
            <span class="font-bold ml-2">`+event.distance+` Miles away</span>
            <p class="mb-5 map_address">
              <a target="_blank" href="https://maps.google.com/?q=`+event.lat+`,`+event.long+`">`+event.event_address+`</a>
              <span>
                <ion-icon class="cursor-pointer" onclick="Window.myComponent.copyToClipboard('`+event.event_address+`')" name="copy-outline"></ion-icon>
                <span id="custom-tooltip" class="capitalize text-black bg-white font-bold" style="padding: 2px 7px;  border-radius: 4px; display: none;">copied</span>
              </span>
            </p>
          </span>
        </p>
      </div>`,
      });
      this.bandMarkerPositions.push({
        lat: Number(event.lat),
        lng: Number(event.long),
      });

      this.display = {
        lat: Number(event.lat),
        lng: Number(event.long),
      };
      this.center = {
        lat: Number(event.lat),
        lng: Number(event.long),
      };
    });
  }

  goToProfile(user_id, account_type) {
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';

    console.log("type", type);
    const loggedInId = JSON.parse(localStorage.getItem('user_profile')) ? JSON.parse(localStorage.getItem('user_profile')).id : '';
    if(user_id == loggedInId)
      this.router.navigate(['profile']);
    else
      this.router.navigate([type + '/' + btoa(user_id)]);
  }

  showMapView() {
    this.selected_category.nativeElement[1].selected = true;
    this.removeActiveDateClass();
    if (!this.isMobileDevice)
      this.hideCalendarMonthViewGrid();
    // if (this.selectedAccountType === 'all') {
    //   this.getAllEvents();
    // } else {
    //   this.getAccountTypeEvents(this.selectedAccountType);
    // }
    this.isCalendarView = false;
    this.isMapView = true;
    if (window.innerWidth < 1024) {
      this.getStartEndDate();
      this.getHeaderDate();
      this.getPrevArrow();
      this.getNextArrow();
    } else {
      this.getStartEndDate();
    }
  }

  showCalendarView() {
    this.selected_category.nativeElement[1].selected = true;
    this.removeActiveDateClass();
    if (!this.isMobileDevice)
      this.showCalendarMonthViewGrid();
    this.isMapView = false;
    this.isCalendarView = true;
    this.showCalendar();
  }

  copyToClipboard = str => {
    if(!navigator.clipboard){
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      document.getElementById("custom-tooltip").style.display = "inline";
      setTimeout( function() {
        document.getElementById("custom-tooltip").style.display = "none";
      }, 1000);
    }else{
      navigator.clipboard.writeText(str).then(function() {
        document.getElementById("custom-tooltip").style.display = "inline";
        setTimeout( function() {
          document.getElementById("custom-tooltip").style.display = "none";
        }, 1000);
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }


  async openFilterEventsModal() {
    this.selected_category.nativeElement[1].selected = true;
    this.removeActiveDateClass();

    //initialize filters
    this.showRadialDistance = false;
    this.moveEnd = 50;
    this.distance = null;
    this.categoriesArray = [];
    this.keyword_search = '';
    this.isShowMap = true;
    this.isShowList = false;
    //#initialize filters

    this.isFilterEventsModalOpen = true;
  }

  onWillDismiss(e){
    this.isFilterEventsModalOpen = false;
  }

  closeFilterEventsModal() {
    this.isFilterEventsModalOpen = false;
  }

  onIonKnobMoveEnd(ev: Event) {
    this.moveEnd = (ev as RangeCustomEvent).detail.value;
    this.distance = this.moveEnd;
  }

  showMap() {
    this.isShowMap = true;
    this.isShowList = false;

    this.isCalendarView = false;
    this.isMapView = true;
  }

  showList() {
    this.isShowList = true;
    this.isShowMap = false;

    this.isCalendarView = true;
    this.isMapView = false;
  }

  applyFilters() {
    this.showSpinner = true;
    let data = {
      start_date: this.start_date_selected,
      end_date: this.end_date_selected,
      radial_distance: this.distance,
      categories: this.categoriesArray,
      keyword: this.keyword_search
    }

    this.getFilteredEvents(data);
  }

  modifyCategorySelection(event:any, id:number) {
    if (event.target.checked){
      this.categoriesArray.push(id);
    } else {
      var index = this.categoriesArray.findIndex(x => x === id);
      if (index > -1) {
        this.categoriesArray.splice(index,1);
      }
    }
    console.log(this.categoriesArray);
  }

  toggleRadialDistance(event:any) {
    if (event.target.checked) {
      this.showRadialDistance = true;
      this.distance = this.moveEnd;
    } else {
      this.showRadialDistance = false;
      this.distance = null;
    }
  }

  getFilteredEvents(data) {
    this.subscription.sink = this.eventsService.getFilteredEvents(data).subscribe(
      (res: any[]) => {
        this.showSpinner = false;
        this.dateEvents = res['data'];
        this.closeFilterEventsModal();
        if (this.isShowMap) {
          this.showEventsGoogleMap(this.dateEvents);
          this.showMap();
        }
        else {
          this.showList();
        }
      }, (error) => {
        this.showSpinner = false;
        this.response_message = "A problem occurred filtering the events, try again later.";
        this.presentErrorToast(this.response_message);
        // console.log(error);
      }
    );
  }

  // getButtonSearchFilteredEvents() {      //on search button click
  //   let data = {
  //     start_date: this.start_date_selected,
  //     end_date: this.end_date_selected,
  //     radial_distance: null,
  //     categories: [],
  //     keyword: this.keyword_search
  //   }
  //   this.subscription.sink = this.eventsService.getFilteredEvents(data).subscribe(
  //     (res: any[]) => {
  //       this.dateEvents = res['data'];
  //       if (this.dateEvents && this.calendar) {
  //         this.calendarOptions.events = this.dateEvents.map((evt) => {
  //           return {
  //             title: evt.event_title,
  //             start: evt.event_date,
  //             end: evt.event_end_date,
  //             eventId: evt.id,
  //           };
  //         });
  //       }
  //       this.showEventsGoogleMap(this.dateEvents);
  //     },
  //     (error) => {
  //       console.log(error);
  //     }
  //   );
  // }

  getSearchFilteredEvents(event) {
    // if (event.which == 8 && this.keyword_search === ""){    //on pushing backspace and empty search
      let data = {
        start_date: this.start_date_selected,
        end_date: this.end_date_selected,
        radial_distance: null,
        categories: [],
        keyword: this.keyword_search
      }
      this.subscription.sink = this.eventsService.getFilteredEvents(data).subscribe(
        (res: any[]) => {
          this.dateEvents = res['data'];
          if (this.dateEvents && this.calendar) {
            this.calendarOptions.events = this.dateEvents.map((evt) => {
              return {
                title: evt.event_title,
                start: evt.event_date,
                end: evt.event_end_date,
                eventId: evt.id,
              };
            });
          }
          this.showEventsGoogleMap(this.dateEvents);
        },
        (error) => {
          console.log(error);
        }
      );
    // } else {
    //   let data = {
    //     start_date: this.start_date_selected,
    //     end_date: this.end_date_selected,
    //     radial_distance: null,
    //     categories: [],
    //     keyword: this.keyword_search
    //   }
    //   this.subscription.sink = this.eventsService.getFilteredEvents(data).subscribe(
    //     (res: any[]) => {
    //       this.dateEvents = res['data'];
    //       if (this.dateEvents && this.calendar) {
    //         this.calendarOptions.events = this.dateEvents.map((evt) => {
    //           return {
    //             title: evt.event_title,
    //             start: evt.event_date,
    //             end: evt.event_end_date,
    //             eventId: evt.id,
    //           };
    //         });
    //       }
    //       this.showEventsGoogleMap(this.dateEvents);
    //     },
    //     (error) => {
    //       console.log(error);
    //     }
    //   );
    // }
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

}
